import { isNil } from 'ramda';
import { PinnedAppsMap } from '~/scenes/Settings/Widget/states/pinnedApps';

const itemIsPinned = (id: string, pinnedApps: PinnedAppsMap) =>
  !isNil(pinnedApps[id]);

export default itemIsPinned;
